/*
 * @Author: liangen(80398513)
 * @Date: 2023-10-16 16:49:17
 * @Description: 
 * @LastEditors: liangen(80398513)
 */
import axios from '@/utils/request'
import { getParmeterSplic } from '@/utils/utils'

/**
 * @description 个人信息-用户信息
 * @param params
 * @returns
 */
export async function getUserInfo() {
  return axios.get('/v2/rbac/personalInfo/userInfo')
}

/**
 * @description 判断是否是超管
 * @param params
 * @returns
 */
export async function getIsManage() {
  return axios.get('/v2/feedback/commonApi/ifManager')
}

/**
 * @description
 * @param params
 * @returns
 */
export async function commonSourceShare(params) {
  return axios.post('/v2/rbac/commonApi/sourceShare', params)
}

/**
 * @description 个人信息-我的资源
 * @param params
 * @returns
 */
export async function getSource(params) {
  return axios.get(`/v2/rbac/personalInfo/source?${getParmeterSplic(params)}`)
}
/**
 * @description 个人信息-最近动态
 * @param params
 * @returns
 */
export async function getLatestDynamics(params) {
  return axios.get(`/v2/rbac/personalInfo/latestDynamics?${getParmeterSplic(params)}`)
}
/**
 * @description
 * @param params
 * @returns
 */
export async function get(params) {
  return axios.get(`/v2/rbac/personalInfo/userInfo?${getParmeterSplic(params)}`)
}

/**
 * @description 调研概览
 * @param params
 * @returns
 */
 export async function feedbackOverView(params) {
  return axios.get(`/v2/feedback/api/research/feedbackOverView`)
}
/**
 * @description 预警概览
 * @param params
 * @returns
 */
 export async function forewarningOverView(params) {
  return axios.get(`/v2/feedback/api/forewarning/forewarningOverView`)
}
